import { useFormContext } from "react-hook-form";

import { useGetCommunitiesLazyQuery } from "@covertree/new-business-graphql";
import { FormAsyncSelect } from "@covertree/ui";

import { HomeDetailsForm } from "../validatorsAndTypes/homeDetailsAndConstructionForm";
import {
  selectBasicQuestions,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";

interface Props {
  stateCode?: string;
  id?: string;
  name?: string; // @TODO investigate why "Path" from "react-hook-form" type is not working
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  dataTestId?: string;
  fontSize?: number;
  labelFontSize?: number;
}

export function CommunityNamesSelect({
  id = "community-name",
  name = "communityName",
  label = "What’s the name of your community?",
  placeholder = "Type at least 3 characters",
  disabled,
  dataTestId = "community-name-input",
  stateCode,
  fontSize,
  labelFontSize,
}: Props) {
  const { communityName } = useNewBusinessSelector(selectBasicQuestions);

  const { control } = useFormContext<HomeDetailsForm>();

  const [getCommunities, { data, loading, previousData }] =
    useGetCommunitiesLazyQuery();

  return (
    <FormAsyncSelect
      id={id}
      fontSize={fontSize}
      labelFontSize={labelFontSize}
      dataTestId={dataTestId}
      name={name}
      label={communityName?.label ?? label}
      placeholder={placeholder}
      defaultSearch={stateCode ? `${stateCode} ` : undefined}
      data={data?.getParameters}
      initialData={previousData?.getParameters}
      loading={loading}
      control={control}
      onGetAsyncData={getCommunities}
      disabled={disabled}
      inputStyle={{
        padding: "0px !important",
      }}
      inputProps={{
        sx: {
          padding: "0 13px 0 14px !important",
        },
      }}
      withCustomValue
    />
  );
}
